import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectPublicationDate = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('publish_period')(jsonQuery),
);
